"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function generateNodePrefix(reqId) {
    if (typeof reqId !== 'string')
        return 'b-id';
    var hash = 0;
    for (var i = 0; i < reqId.length; i++) {
        hash ^= (hash << 5) + (hash >>> 2) + reqId.charCodeAt(i);
    }
    hash &= 1048575;
    return hash.toString(36);
}
function getSenderParams(args) {
    if ('hrefPostfix' in args) {
        var hrefPostfix = args.hrefPostfix, hrefPrefix = args.hrefPrefix;
        return { hrefPostfix: hrefPostfix, hrefPrefix: hrefPrefix };
    }
    var reqId = args.reqId, table = args.table, service = args.service, slots = args.slots;
    var slotsPart = Array.isArray(slots) ? '/slots=' + slots.join(';') : '';
    return {
        hrefPostfix: '/*//' + args.pageUrl,
        hrefPrefix: "https://yandex.ru/clck/click/reqid=" + reqId + slotsPart + "/table=" + (table || service),
    };
}
function getBaobabInitState(args) {
    var reqId = args.reqId;
    var prefix = generateNodePrefix(reqId);
    var senderParams = getSenderParams(args);
    return { prefix: prefix, senderParams: senderParams };
}
exports.getBaobabInitState = getBaobabInitState;
